import * as types from "@/store/mutation-types";
import { DefineMutations } from "vuex-type-helper";
import {
  RoofStructureState,
  RoofStructureMutations,
  StateKeys,
  IRoofStructure
} from "./types";
import {
  GenericClearStore,
  GenericDeleteItem,
  GenericSetEdit,
  GenericSetEditField,
  GenericSetItem,
  GenericSetState,
  GenericSetStates
} from "@/store/helpers";
import { defaultState } from "./state";
import { roofStructureDefault } from "@/helpers/roofStructureDefault";

export const mutations: DefineMutations<
  RoofStructureMutations,
  RoofStructureState
> = {
  [types.SET_STATE]: GenericSetState<RoofStructureState, StateKeys>(),
  [types.SET_STATES]: GenericSetStates<RoofStructureState>(),
  [types.SET_EDIT]: GenericSetEdit<
    RoofStructureState,
    string | Partial<IRoofStructure>
  >("roofStructures", roofStructureDefault),
  [types.SET_EDIT_FIELD]: GenericSetEditField<
    RoofStructureState,
    keyof IRoofStructure
  >(),
  [types.SET_ITEM]: GenericSetItem<RoofStructureState, IRoofStructure>(
    "roofStructures",
    roofStructureDefault
  ),
  [types.DELETE_ITEM]: GenericDeleteItem<RoofStructureState>(
    "roofStructures",
    "_id"
  ),
  [types.CLEAR_ROOF_STRUCTURE_STORE]: GenericClearStore<RoofStructureState>(
    defaultState()
  )
};
